import { api } from './client';
import type { ProvinceEventPageDto } from '../types/provinceEvents';

export async function getProvinceEvents(
  worldId: string,
  provinceId: string,
  params: { before?: number; limit?: number; unseen?: boolean } = {}
) {
  const query = new URLSearchParams();
  if (params.before != null) query.set('before', String(params.before));
  if (params.limit != null) query.set('limit', String(params.limit));
  if (params.unseen != null) query.set('unseen', String(params.unseen));
  const qs = query.toString() ? `?${query.toString()}` : '';
  return api.get<ProvinceEventPageDto>(
    `/api/worlds/${worldId}/provinces/${provinceId}/events${qs}`
  );
}

export async function advanceProvinceEventCursor(
  worldId: string,
  provinceId: string,
  cursor: number
) {
  return api.put<{ cursor: number }>(
    `/api/worlds/${worldId}/provinces/${provinceId}/events/cursor`,
    { cursor }
  );
}
